interface AppConfig {
  fontFamily: string;
  borderRadius: number;
  outlinedFilled: boolean;
  navType: "light" | "dark";
  presetColor: "default";
  locale: "en" | "fr" | "ro" | "zh";
  rtlLayout: boolean;
  container: boolean;
}

export const AWS_API_NEW = {
  UserPoolId: import.meta.env.VITE_USER_POOL_ID,
  ClientId: import.meta.env.VITE_CLIENT_ID,
  IdentityPoolId: import.meta.env.VITE_IDENTITY_POOL_ID,
  CognitoRoutePrefix: import.meta.env.VITE_COGNITO_ROUTE_PREFIX,
  Region: import.meta.env.VITE_REGION,
};

export const BASE_PATH = "";

export const DASHBOARD_PATH = "/voyages";

const config: AppConfig = {
  fontFamily: `'Roboto', sans-serif`,
  borderRadius: 8,
  outlinedFilled: true,
  navType: "light",
  presetColor: "default",
  locale: "en",
  rtlLayout: false,
  container: false,
};

export default config;
